// extracted by mini-css-extract-plugin
export default {"firstImage":"static-pages_firstImage__15syE","secondImage":"static-pages_secondImage__AEfc1","one":"static-pages_one__KqdoE"};